import { uniq, uniqBy } from 'lodash';
import { COUNTRIES } from './countries';

export const UNIQUE_NATIONALITIES = uniq(
  COUNTRIES.map((country) => country.nationality)
);

export const NATIONALITY_OPTIONS = uniqBy(
  COUNTRIES.map((country) => ({
    value: country.alpha_2_code,
    label: country.nationality,
  })),
  'value'
);

export const NATIONALITY_NAME_OPTIONS = UNIQUE_NATIONALITIES.map(
  (nationality) => ({
    value: nationality,
    label: nationality,
  })
);
